import translate from "./translate";
import Templater from "./Templater";

export default class FinnTemplater extends Templater {
  noItemsBlock() {
    const { landingPageUrl, contactsEnabled } = this.options;

    const node = document.createElement("article");

    node.classList.add("main-tiles__unit");
    node.classList.add("empty");

    if (!contactsEnabled) {
      node.classList.add("contacts-disabled");
    }

    node.innerHTML = `<div class="tile one-block">
      <div>
        <div class="tile__placeholder">
          <div class="tile__placeholder-img">
            <image src="/finn-no-item.svg" alt="" />
          </div>
          <p class="tile__noitem-text">
            ${translate("finn_empty_slide_message")}
          </p>
          ${
            !landingPageUrl
              ? ""
              : `
                <a href="${landingPageUrl}" target="_blank" class="tile__placeholder-button">
                  ${translate("contact_us_button_text")}
                  <span class="visually-hidden">${translate("opens_in_new_window")}</span>
                </a>
                `
          }
        </div>
      </div>
    </div>`;

    return node;
  }

  tile(data) {
    if (!data) return null;
    const { landingPageUrl, contactsEnabled } = this.options;

    const tileNode = document.createElement("article");
    tileNode.classList.add("main-tiles__unit");

    if (!data.id) {
      tileNode.classList.add("empty");
      if (!contactsEnabled) {
        tileNode.classList.add("contacts-disabled");
      }

      tileNode.innerHTML = `<div class="tile">
        <div>
          <div class="tile__placeholder">
            <div class="tile__placeholder-img">
              <image src="/finn-no-item.svg" alt="" />
            </div>
            <p class="tile__noitem-text">
              ${translate("finn_empty_slide_message")}
            </p>
            ${
              !landingPageUrl
                ? ""
                : `
                  <a href="${landingPageUrl}" target="_blank" class="tile__placeholder-button">
                    ${translate("contact_us_button_text")}
                          <span class="visually-hidden">${translate("opens_in_new_window")}
                    </span>
                  </a>
                  `
            }
          </div>
        </div>
      </div>`;
    } else {
      tileNode.innerHTML = `
        <a href="${data.link || "javascript:void(0)"}" data-id="${data.id}" target="_blank" class="tile">
          <div>
            <div class="tile__wrapper">
              <div class="tile__img-wrapper">
                <img class="tile__img" data-img="${data.image || data.small_image || ""}" alt="" />
                <div class="tile__img-loader"></div>
              </div>
              <div class="tile__content tile__promotion-content">
                
                <div class="tile__content-header">
                  <h2 class="tile__title">${data.title ?? ''}</h2>
                  <p class="tile__description">${data.description ?? ''}</p>
                </div>

                <div class="tile__content-wrapper">
                  <p class="tile__price">${data.price ? Number(data.price).toLocaleString('nb-NO') + ',-' : ''}</p>
                  <p class="tile__mileage">${data.mileage ? data.mileage.toLocaleString('nb-NO') + ' km' : ''}</p>
                </div>

                <div class="tile__content-footer">
                  ${
                    data.customer &&
                    data.customer.display_logo &&
                    data.customer.logo_thumb_url
                      ? `
                  <div class="tile__logo">
                    <img alt="${data.customer.name}" src="${data.customer.logo_thumb_url}" />
                  </div>
                  `
                      : ""
                  }
                  ${
                    data.customer && data.customer.name
                      ? `
                    <h3 class="tile__name">
                      ${data.customer.name}
                    </h3>
                  `
                      : ""
                  }
                </div>
              </div>
            </div>
          </div>
          <span class="visually-hidden">${translate("opens_in_new_window")}</span>
        </a>
      `;
    }

    return tileNode;
  }

  static uploadImages(container) {
    const imagesNodes = container.querySelectorAll(".tile__img[data-img]");

    for (let i = 0; i < imagesNodes.length; i += 1) {
      const node = imagesNodes[i];
      const src = node.getAttribute("data-img");

      if (typeof src !== "undefined" && src !== null && src.length > 0) {
        if (node.tagName === "IMG") {
          const img = new window.Image();
          img.onload = () => {
            node.src = src;
            node.removeAttribute("data-img");
            const loader = node.parentElement?.querySelector(".tile__img-loader");
            if (loader) loader.style.display = "none";
          };
          img.onerror = () => {
            node.removeAttribute("data-img");
            const loader = node.parentElement?.querySelector(".tile__img-loader");
            if (loader) loader.style.display = "none";
          };
          img.src = src;
        }
      }
    }
  }
}
